export default __webpack_public_path__ + "static/ETH-23ca4a5fb8f08bd86897ca75ebaab58c.png";